import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  700: { name: 'Chimney Repairs' },
  701: { name: 'Fascias, Soffits & Guttering' },
  702: { name: 'Flat Roofing' },
  703: { name: 'Leadwork' },
  704: { name: 'Pitched Roofing' },
  705: { name: 'Roof Inspections' },
};

const AdminRoofingPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Roofing Pricing Rules"
    description="Manage pricing for 6 roofing services"
  />
);

export default AdminRoofingPricingRules;
